import { PlannerItemModelTypeEnum } from '../enums/plannerItemModelType.enum';

type AllowedModelType =
  | PlannerItemModelTypeEnum.event
  | PlannerItemModelTypeEnum.meet
  | PlannerItemModelTypeEnum.appointment
  | PlannerItemModelTypeEnum.task
  | PlannerItemModelTypeEnum.reminder;

export const removeItemFromPlannerList = (
  plannerList: any,
  id: number,
  modelType: PlannerItemModelTypeEnum,
) => {
  const countsMap: Record<AllowedModelType, string> = {
    [PlannerItemModelTypeEnum.event]: 'eventCount',
    [PlannerItemModelTypeEnum.meet]: 'eventCount',
    [PlannerItemModelTypeEnum.appointment]: 'eventCount',
    [PlannerItemModelTypeEnum.task]: 'taskCount',
    [PlannerItemModelTypeEnum.reminder]: 'reminderCount',
  };

  return plannerList
    .map((day: any) => {
      const newItems = day.items.filter((item: any) => item.id !== id);
      const isContainInThisDay = newItems.length !== day.items.length;

      return {
        ...day,
        [countsMap[modelType as AllowedModelType]]: isContainInThisDay
          ? day[countsMap[modelType as AllowedModelType]] - 1
          : day[countsMap[modelType as AllowedModelType]],
        items: newItems,
      };
    })
    .filter((day: any) => day.items.length > 0);
};
